import BaseUseCase from "../../../base_use_case.js";

class UnpublishProjectUseCase extends BaseUseCase {

  execute(identifier) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "post",
      url: `/api/v1/admin/projects/projects/${identifier}/unpublish`,
      data: {
        findBySlug: true
      },
    });
  }
}

const instance = new UnpublishProjectUseCase();
export default instance;